export default "__VITE_ASSET__$aJjzcqk__"